<template>
  <div class="wrapper">
    <AppLogo variant="prelogin"/>
    <OTPInvitationVerifyForm/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import AppLogo from "@/components/Widgets/AppLogo.vue";
import OTPInvitationVerifyForm from "@/components/FK/UserForm/OTPInvitationVerifyForm.vue";

export default defineComponent({
  name: "OTPInvitationVerifyPage",
  components: {
    AppLogo,
    OTPInvitationVerifyForm
  },
  data: function() {
    return {
      lang: this.$route.query?.lang as string | undefined,
    }
  }
});
</script>